/**
 * Copyright (C) 2025 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */
import { Divider, FormControlLabel } from '@mui/material';
import Button from '@mui/material/Button';
import styled from 'styled-components';
import StyledProps from '../theme/AppThemeInterface';

export const DROPDOWN_WIDTH = '287px';

export const StyledSection = styled.div<{ $height?: number }>`
  min-height: ${(props: { $height: number }) => props.$height}px;

  .overlays__header {
    color: white;
    font-family: ${({ theme }: StyledProps) => theme.appFontFamily};
    font-size: 12px;
    letter-spacing: 0.5px;
    line-height: 15px;

    margin: 15px 16px 0;
  }
`;

export const DropDownWrapper = styled.div`
  padding: 14px 16px 0;
`;

export const LabeledCheckbox = styled(FormControlLabel)`
  height: 36px;
  padding: 8px 16px 0 24px;
  display: flex;
  flex-direction: row;

  .label {
    font-family: ${({ theme }: StyledProps) => theme.appFontFamily};
    font-size: 14px;
    color: white !important;
    line-height: 20px;
  }
`;

export const AlternativeContainer = styled.div<{ $height?: number }>`
  min-height: ${(props: { $height: number }) => props.$height}px;
  padding: 15px 15px 0;

  color: ${({ theme }: StyledProps) => theme.primaryTextColor};

  align-items: center;
  justify-content: center;
  text-align: center;
`;

export const StyledButton = styled(Button)`
  color: ${({ theme }: StyledProps) => theme.buttonSelectedColor};
`;

export const StyledDivider = styled(Divider)`
  // Increases the specificity of the CSS selector, so it can override the styled <hr> in StyledPanel (OverlaysWrapper)
  && {
    border-top: 1px solid ${({ theme }: StyledProps) => theme.terminalListBorderColor}; // Changes the color of the divider
    margin-top: 15px;
    margin-bottom: 10px;
  }
`;